import { Trans } from '@lingui/macro';

// Device owner type — only 'wired' devices can be rescanned/deleted
export const DEVICE_OWNER_WIRED = 'wired';
export const DEVICE_OWNER_WIRELESS = 'wireless';

// Monitoring IP API paths
export const DEVICE_IP_COLLECTORS_PATH = 'ipAddresses/collectors';
export const DEVICE_INTERFACES_PATH = 'interfaces';
export const DEVICE_QUERY_BASE_URL = '/ngp/v2/devices';

// Interface table
export const INTERFACE_ACTION_BASE_URL = '/ipm/v1/admin/interfaces';

// Interface action URLs
export const INTERFACE_ENABLE_URL = `${INTERFACE_ACTION_BASE_URL}/enableInterfacesSelection`;
export const INTERFACE_DISABLE_URL = `${INTERFACE_ACTION_BASE_URL}/disableInterfacesSelection`;
export const INTERFACE_POLLING_AUTO_URL = `${INTERFACE_ACTION_BASE_URL}/applyInterfaceSelectionRule`;
export const INTERFACE_PRIORITY_HIGH_URL = `${INTERFACE_ACTION_BASE_URL}/highPriorityInterfacesSelection`;
export const INTERFACE_PRIORITY_LOW_URL = `${INTERFACE_ACTION_BASE_URL}/lowPriorityInterfacesSelection`;
export const INTERFACE_PRIORITY_AUTO_URL = `${INTERFACE_ACTION_BASE_URL}/applyInterfacePriorityRule`;
export const INTERFACE_SPEED_URL = `${INTERFACE_ACTION_BASE_URL}/speedInterfacesSelection`;

export const INTERFACE_POLLING_ENABLE = 'Enable';
export const INTERFACE_POLLING_DISABLE = 'Disable';
export const INTERFACE_POLLING_AUTO = 'Polling_Auto';
export const INTERFACE_PRIORITY_HIGH = 'High';
export const INTERFACE_PRIORITY_LOW = 'Low';
export const INTERFACE_PRIORITY_AUTO = 'Priority_Auto';
export const INTERFACE_SPEED = 'Speed';

export const INTERFACE_ACTION_URLS = {
    [INTERFACE_POLLING_ENABLE]: INTERFACE_ENABLE_URL,
    [INTERFACE_POLLING_DISABLE]: INTERFACE_DISABLE_URL,
    [INTERFACE_POLLING_AUTO]: INTERFACE_POLLING_AUTO_URL,

    [INTERFACE_PRIORITY_HIGH]: INTERFACE_PRIORITY_HIGH_URL,
    [INTERFACE_PRIORITY_LOW]: INTERFACE_PRIORITY_LOW_URL,
    [INTERFACE_PRIORITY_AUTO]: INTERFACE_PRIORITY_AUTO_URL,

    [INTERFACE_SPEED]: INTERFACE_SPEED_URL,
};

// Radios
export const RADIOS_URL = '/ipm/v1/admin/radios';

// Access Points
export const ACCESS_POINTS_URL_SUFFIX = 'listAccessPointsByWLC';

// Speed presets (bps)
export const SPEED_100M = 100000000;
export const SPEED_1G = 1000000000;
export const SPEED_10G = 10000000000;
export const SPEED_AUTO = 0;

// Speed suffix multipliers
export const SPEED_MULTIPLIERS = {
    K: 1e3,
    M: 1e6,
    G: 1e9,
    T: 1e12,
};

// Device detail field names
export const MANUAL_NAME_FIELD = 'manualName';
export const DEVICE_TYPE_FIELD = 'deviceType';
export const OWNER_FIELD = 'owner';
export const DISABLED_FIELD = 'disabled';
export const USER_SELECTED_MONITORING_IP_FIELD = 'userSelectedMonitoringIp';
export const SYS_NAME_FIELD = 'sysName';
export const SYS_DESCRIPTION_FIELD = 'sysDescription';
export const DEVICE_MODEL_FIELD = 'deviceModel';
export const VENDOR_FIELD = 'vendor';
export const OPERATING_SYSTEM_FIELD = 'operatingSystem';
export const UP_TIME_FIELD = 'upTime';
export const CONTACT_FIELD = 'contact';
export const MAC_ADDRESS_FIELD = 'macAddress';
export const SERIAL_NUMBER_FIELD = 'serialNumber';
export const LOCATION_FIELD = 'location';
export const IP_ADDRESSES_FIELD = 'ipAddresses';
export const CREDENTIAL_FIELD = 'credentialstring';
export const CREDENTIAL_TIME_FIELD = 'credentialtime';
export const WIRELESS_CONTROLLER_FIELD = 'wirelessController';
export const CONNECT_STATUS_FIELD = 'connectStatus';
export const STATE_FIELD = 'state';
export const SUB_TYPE_FIELD = 'subType';

// Server-specific fields
export const COMPUTER_NAME_FIELD = 'computerName';
export const COMPUTER_DESCRIPTION_FIELD = 'computerDescription';
export const DOMAIN_FIELD = 'domain';
export const WORKGROUP_FIELD = 'workgroup';
export const PROCESSOR_FIELD = 'processor';
export const INSTALLED_MEMORY_FIELD = 'installedMemory';
export const NICS_FIELD = 'nics';

// Labels
// Note: LABEL_VENDOR, LABEL_IP_ADDRESSES, LABEL_CREDENTIAL imported from InfrastructureConstants
export const LABEL_MANUAL_NAME = <Trans>Name</Trans>;
export const LABEL_SYS_NAME = <Trans>Name</Trans>;
export const LABEL_SYS_DESCRIPTION = <Trans>Description</Trans>;
export const LABEL_DEVICE_MODEL = <Trans>Model</Trans>;
export const LABEL_OPERATING_SYSTEM = <Trans>Operating System</Trans>;
export const LABEL_UP_TIME = <Trans>Up Time</Trans>;
export const LABEL_CONTACT = <Trans>Contact</Trans>;
export const LABEL_MAC_ADDRESS = <Trans>MAC Address</Trans>;
export const LABEL_SERIAL_NUMBER = <Trans>Serial Number</Trans>;
export const LABEL_LOCATION = <Trans>Location</Trans>;
export const LABEL_CREDENTIAL_TIME = <Trans>Credential Time</Trans>;
export const LABEL_MONITORING_IP = <Trans>Monitoring IP</Trans>;
export const LABEL_WIRELESS_CONTROLLER = <Trans>Wireless Controller</Trans>;
export const LABEL_DEVICE_TYPE = <Trans>Type</Trans>;

// Server labels
export const LABEL_COMPUTER_NAME = <Trans>Computer Name</Trans>;
export const LABEL_IP_ADDRESS_NAME = <Trans>IP Address</Trans>;
export const LABEL_COMPUTER_DESCRIPTION = <Trans>Computer Description</Trans>;
export const LABEL_DOMAIN = <Trans>Domain</Trans>;
export const LABEL_WORKGROUP = <Trans>Workgroup</Trans>;
export const LABEL_PROCESSOR = <Trans>Processor</Trans>;
export const LABEL_INSTALLED_MEMORY = <Trans>Installed Memory</Trans>;
export const LABEL_NICS = <Trans>NICs</Trans>;
